import { render, staticRenderFns } from "./BoxUnlockBottom.vue?vue&type=template&id=629c84cd&scoped=true&"
import script from "./BoxUnlockBottom.vue?vue&type=script&lang=js&"
export * from "./BoxUnlockBottom.vue?vue&type=script&lang=js&"
import style0 from "./BoxUnlockBottom.vue?vue&type=style&index=0&id=629c84cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c84cd",
  null
  
)

export default component.exports